import { QueryList } from '@angular/core';

import { YourTeamData } from '../../../core/yourteam-data.model';
import {
    Cell,
    CellNode,
    Column,
    Context,
    DivRendererOptions,
    GridContent,
    Row,
    SelectTemplateFn,
    Sort,
    SortOrder,
    sortOrderWithDefault,
} from '../../../experimental.grid';

import { YourTeamGridColumnId } from './your-team-grid-column-id.model';
import { YourTeamGridData } from './your-team-grid-data.model';
import { YourTeamGridTemplateId } from './your-team-grid-template-id.model';

function selectTpl(): SelectTemplateFn {
    return (
        context: Context,
        contents: QueryList<GridContent>,
    ): GridContent => {
        if (context.t === 'grid') {
            return contents.find((e) => e.type === 'grid');
        }
        if (context.t === 'row') {
            return contents.find(
                (e) =>
                    e.type === 'row' &&
                    e.id ===
                        (!context.ctx || !context.ctx.templateId
                            ? 'header'
                            : context.ctx.templateId),
            );
        }
        if (context.t === 'cell') {
            return contents.find(
                (e) => e.type === 'cell' && e.id === context.ctx.templateId,
            );
        }
    };
}

function willMeasure(node: CellNode): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (node.renderContext && node.renderContext.element) {
        node.renderContext.element.classList.add('yourteam-measure');
    }
}

function didMeasure(node: CellNode): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (node.renderContext && node.renderContext.element) {
        node.renderContext.element.classList.remove('yourteam-measure');
    }
}

export function createGridData(
    data: YourTeamData,
    maxDataRows: number,
): YourTeamGridData {
    const columnIds = [
        YourTeamGridColumnId.USER_NAME,
        YourTeamGridColumnId.SUPER_GROUP,
        YourTeamGridColumnId.PERIOD,
        YourTeamGridColumnId.OVERALL_SCORE,
    ];

    const columns = columnIds.map<Column>((e) => {
        return {
            id: e,
            width: 80,
            ctx: {
                templateId: YourTeamGridTemplateId.HEADER,
                type: e,
            },
            willMeasure,
            didMeasure,
        };
    });

    const rendererOpts: DivRendererOptions = {
        columns,
        defaultRenderFn: null,
        height: 9999,
        horizontalScrollPadding: 9999,
        verticalScrollPadding: 9999,
    };

    const rows = data.roster
        .map<Row>((r, ri) => {
            const cells = columns.map<Cell>((e) => {
                return {
                    columnId: e.id,
                    height: 30,
                    ctx: {
                        templateId: YourTeamGridTemplateId.CONTENT,
                        data: r,
                    },
                    willMeasure,
                    didMeasure,
                };
            });

            return {
                id: `${ri}`,
                height: 80,
                cells,
                ctx: {
                    templateId: YourTeamGridTemplateId.CONTENT,
                },
            };
        })
        .slice(0, maxDataRows);

    const defaultSortDef: Sort = {
        columnId: columnIds[0],
        order: SortOrder.ASC,
    };
    const sortDefs = sortOrderWithDefault(
        columns,
        columns[0],
        null,
        defaultSortDef,
    );

    return {
        rendererOpts,
        selectTpl: selectTpl(),
        rows,
        sortDefs,
    };
}
